// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"382":"ja-JP-main-json","467":"zh-CN-main-json","589":"zh-TW-main-json","872":"en-US-main-json"}[chunkId] + "." + {"382":"d588d820","467":"e13742cd","589":"f37073ef","872":"99fa9fbe"}[chunkId] + ".chunk.js";
};